import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  BackgroundArea,
  RowView,
  TitleArea,
} from "../../../../Component/style/common_style";

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 25rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 24px;
  overflow: hidden;
  padding: 1.5rem;
  div.info {
    white-space: pre-line;
    line-height: 25px;
  }
`;
const BtnArea = styled(RowView)`
  margin-top: 1rem;
  div {
    flex: 1;
    padding: 0.8rem 0rem;
    ${fontStyles.semiBold};
    text-align: center;
    color: gray;
    background-color: #f8f8f8;
    border-radius: 8px;
    cursor: pointer;
  }
`;

const Block = ({
  visible,
  handleModal,
  ban_popup,
  isLogout,
}: modalProps & { ban_popup: string; isLogout?: boolean }) => {
  const closeModal = () => {
    handleModal();
    if (isLogout) {
      // localStorage.removeItem("key");
      // localStorage.removeItem("authority");
      window.location.href = "/";
    } else {
      window.location.reload();
    }
  };

  return (
    <BackgroundArea style={visible ? {} : { display: "none" }}>
      <ModalBox>
        <TitleArea>
          <div>차단알림</div>
        </TitleArea>

        <div className="info">{ban_popup}</div>

        <BtnArea>
          <div onClick={closeModal}>닫기</div>
        </BtnArea>
      </ModalBox>
    </BackgroundArea>
  );
};

export default Block;
